export const mftCompanies = [
  "MFT1",
  "MFT2",
  "MFT3",
  "MFT4",
  "MFT5",
  "MFT6",
  "MFT7",
  "MFTUS1",
  "MFTUS2",
  "MFTAPAC1",
  "MFTAPAC2",
  "MFTAPAC3"
];

export const MFT_ENERGY_AS = "MFT Energy A/S";
